/*
  Glimot ribbon: fades between announcements. Loaded only when there is more than one announcement and
  auto-rotate is on. Pauses while hovered or focused; with reduced motion the first announcement stays.
  Inactive announcements are hidden from assistive technology so rotation isn't read out repeatedly.
*/
if (!customElements.get('glimot-ribbon')) {
  customElements.define(
    'glimot-ribbon',
    class GlimotRibbon extends HTMLElement {
      connectedCallback() {
        this.messages = [...this.querySelectorAll('.g-ribbon__message')];
        if (this.messages.length < 2) return;
        this.index = Math.max(0, this.messages.findIndex((m) => m.classList.contains('is-active')));
        this.sync();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.delay = Math.max(3, parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.paused = false;
        const pause = () => (this.paused = true);
        const resume = () => (this.paused = false);
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.timer = window.setInterval(() => {
          if (this.paused || document.hidden) return;
          this.index = (this.index + 1) % this.messages.length;
          this.sync();
        }, this.delay);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      sync() {
        this.messages.forEach((message, i) => {
          const active = i === this.index;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', active ? 'false' : 'true');
          message.querySelectorAll('a').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
      }
    }
  );
}
